// @ts-nocheck

(() => {
  "use strict";

  const iniciarPersonalizadorV2 = () => {
    const EL = globalThis.EspacioLaserV2;

    if (!EL || !EL.EngravingEditor) {
      console.error(
        "[EspacioLaserV2] EngravingEditor no está disponible."
      );
      return;
    }

    const editors = EL.EngravingEditor.mountAll();

    globalThis.espacioLaserEngravingEditors = editors;

    console.log(
      "[EspacioLaserV2] Editores iniciados:",
      editors.length
    );
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      iniciarPersonalizadorV2,
      { once: true }
    );
  } else {
    iniciarPersonalizadorV2();
  }
})();